import { AppRouteProps } from "@mzara/component";
import { MindMapEditContainer } from "./containers/MindMapEditContainer";

export const MindMapDetailsEditRoutes: Array<AppRouteProps> = [
    {
        path: 'edit',
        element: <MindMapEditContainer />
    }
]